import { Component, Input, output, inject } from '@angular/core';

import { trackByProp } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import type { ThemeName } from '@core/theme-util';

import type { ThemeCardData } from './theme-card/theme-card.component';
import { ThemeCardComponent } from './theme-card/theme-card.component';

@Component({
  selector: 'rt-theme-picker',
  templateUrl: './theme-picker.component.html',
  styleUrls: ['./theme-picker.component.less'],
  imports: [ThemeCardComponent],
})
export class ThemePickerComponent {
  private readonly i18n = inject(I18nService);

  @Input() public cardWidth: number | undefined;
  @Input() public cardHeight: number | undefined;
  @Input() public activeThemeName: ThemeName;
  @Input() public themeCardBackgroundSize: 'auto' | 'contain';
  public themeChange = output<ThemeName>();

  public themeCards: ThemeCardData[] = [
    {
      title: this.i18n.translate('rtu.theme_picker.light'),
      subtitle: this.i18n.translate('rtu.theme_picker.default_subtitle'),
      theme: 'light',
    },
    {
      title: this.i18n.translate('rtu.theme_picker.dark'),
      theme: 'dark',
    },
    {
      title: this.i18n.translate('rtu.theme_picker.system_preferences_title'),
      theme: 'auto',
      iconHelpTooltip: this.i18n.translate('rtu.theme_picker.system_preferences_help'),
    },
  ];

  public trackByTheme = trackByProp<ThemeCardData>({ prop: 'theme' });
}
